import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CopyPasteStorageService {
  private static readonly DB_NAME = 'kyloe-word-addin-db';
  private static readonly STORE_NAME = 'copy-paste-storage';
  private static readonly KEY_PATH = 'key';
  private static readonly DB_VERSION = 1;

  private idbPromise: Promise<IDBDatabase> | undefined;

  // Storage service uses the IndexedDB API due to storage size concerns with localStorage

  private getDatabaseConnection(): Promise<IDBDatabase> {
    if (this.idbPromise) {
      return this.idbPromise;
    }

    this.idbPromise = new Promise<IDBDatabase>((resolve, reject) => {
      console.log('Opening database for storage service');
      const request = indexedDB.open(CopyPasteStorageService.DB_NAME, CopyPasteStorageService.DB_VERSION);
      // request.onupgradeneeded also covers if there's no database present and it needs to be initialised
      request.onupgradeneeded = () => {
        console.log('Creating database for storage service');
        const idbDatabase = request.result;
        if (!idbDatabase.objectStoreNames.contains(CopyPasteStorageService.STORE_NAME)) {
          idbDatabase.createObjectStore(CopyPasteStorageService.STORE_NAME, {keyPath: CopyPasteStorageService.KEY_PATH});
        }
      };

      request.onsuccess = () => {
        resolve(request.result);
      };
      request.onerror = () => {
        reject(request.error);
      };
    });
    return this.idbPromise;
  }

  async setItem(key: string, value: string): Promise<void> {
    const idbDatabase = await this.getDatabaseConnection();

    await new Promise<void>((resolve, reject) => {
      const transaction = idbDatabase.transaction(CopyPasteStorageService.STORE_NAME, 'readwrite');
      const store = transaction.objectStore(CopyPasteStorageService.STORE_NAME);
      const request = store.put({ key, value });
      request.onsuccess = () => {
        console.log('Stored item in storage service');
        resolve();
      };
      request.onerror = () => {
        console.error('Failed to store item in storage service', request.error);
        reject(request.error);
      };
    });
  }

  async getItem(key: string): Promise<string | null> {
    const db = await this.getDatabaseConnection();

    return await new Promise<string | null>((resolve, reject) => {
      const transaction = db.transaction(CopyPasteStorageService.STORE_NAME, 'readonly');
      const store = transaction.objectStore(CopyPasteStorageService.STORE_NAME);
      const request = store.get(key);
      request.onsuccess = () => {
        console.log('Got item from storage service');
        resolve(request.result ? request.result.value : null);
      };
      request.onerror = () => {
        console.error('Failed to get item from storage service', request.error);
        reject(request.error);
      };
    });
  }
}
